import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { EditProductComponent } from "../edit-product.component";
import { ToastrService } from "ngx-toastr";

@Component({
	selector: "meu-modal-upload-image",
	templateUrl: "./modal-upload-image.component.html",
	styleUrls: ["./modal-upload-image.component.scss"],
})
export class ModalUploadImageComponent implements OnInit {
	files: File[] = [];
	summaryImage = "";
	physical_path = "";
	isEdit = false;
	imageDefault = null;

	constructor(
		public dialogRef: MatDialogRef<EditProductComponent>,
		@Inject(MAT_DIALOG_DATA) public data,
		private toastr: ToastrService
	) {}

	ngOnInit() {
		if (this.data.itemImage) {
			this.isEdit = true;
			this.summaryImage = this.data.itemImage.summary;
			this.imageDefault = this.data.itemImage.physical_path;
		} else {
			this.isEdit = false;
		}
	}

	closeModal() {
		this.dialogRef.close({ event: false });
	}

	onSelect(event) {
		this.files = [];
		this.files.push(...event.addedFiles);
		this.imageDefault = null;
	}

	onRemove(event) {
		this.files.splice(this.files.indexOf(event), 1);
	}

	save() {
		if (this.files.length == 0 && !this.isEdit) {
			this.toastr.warning("Vui lòng chọn hình ảnh");
			return;
		} else if (this.imageDefault) {
			this.toastr.warning("Chưa chọn ảnh mới");
			return;
		}

		var reader = new FileReader();
		reader.onload = this.handleFile.bind(this);
		reader.readAsBinaryString(this.files[0]);
	}

	handleFile(event) {
		var binaryString = event.target.result;
		let base64textString = btoa(binaryString);
		base64textString = "data:image/png;base64," + base64textString;
		this.physical_path = base64textString;
		this.dialogRef.close({
			event: true,
			file: this.files[0],
			physical_path: this.physical_path,
			summary: this.summaryImage,
		});
	}
}
